<template>
  <h1 class="d-flex justify-content-center">Oops, it looks like the page you're looking for doesn't exist.</h1>
</template>